import {useQuery} from '@tanstack/react-query';

import {apiService} from '../apiService';
import {useAuth} from '../contexts/AuthContext';

export const employeeRecordingsQueryKey = (employeeId) => [
  'employeeRecordings',
  employeeId,
];

const RECORDINGS_POLL_INTERVAL_MS = 60_000;

export const useEmployeeRecordings = () => {
  const {user} = useAuth();
  const employeeId = user?.employee_id;

  const query = useQuery({
    queryKey: employeeRecordingsQueryKey(employeeId),
    queryFn: async () => {
      const data = await apiService.get(
        `/api/get-employee-recordings?employee_id=${employeeId}`,
      );
      if (!data || data.error === 'No recordings') return [];
      return Array.isArray(data) ? data : [];
    },
    enabled: !!employeeId,
    refetchInterval: RECORDINGS_POLL_INTERVAL_MS,
  });

  return query;
};
